export default __webpack_public_path__ + "static/2022-60e9feacc5a980e308b566cd81f4748b.svg";